<!-- static content data from lang: questionnaires -->
<template>
  <div>
    <div class="h-100" v-loading="loading">
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-12 col-12">
          <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.AddheaderTitle}}</h6>
          <nav aria-label="breadcrumb" class="d-inline-block ml-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
          <div class="col-md-12">
            <Alert :type=type dismissible  v-if="alertMessage">  <span class="alert-inner--text">{{alertMessage}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
            <validation-observer v-slot="{handleSubmit}" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-md-12">
                        <base-input
                          :label="lang.label.questionnaires"
                          name="questionnaires"
                          :rules="{required: true}"
                          v-model="model.questionnaires"
                          autocomplete="off"
                          labelClasses="form-control-label asterisk-mark"
                        ></base-input>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-right mb-3">
                  <base-button type="primary" native-type="submit">{{lang.label.buttons.save}}</base-button>
                  <base-button
                    type="danger"
                    @click="$router.push({name: 'questionnaires'})"
                  >{{lang.label.buttons.cancel}}</base-button>
                </div>
              </form>
            </validation-observer>
          </div>
        </card>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import Alert from "@/components/BaseAlert.vue";

export default {
  components: {
    RouteBreadCrumb,
    Alert
  },
  data() {
    return {
      lang: this.$lang.questionnaires,
      loading : false,
      model: {
          questionnaires: ""
      },
      alertMessage:""
    };
  },
  methods: {
    onSubmit() {
      this.loading = true;
       let data = {
               "Name":this.model.questionnaires ,
            };
            this.$store.dispatch('createQuestionnaires', data)
                    .then(response => {
                       if (response.status == 200) {
                      this.model.questionnaires = '';
                      this.flash({message: response.data.message, variant: 'success'});
                        this.$router.push({ name: "questionnaires" });
                        this.loading = false;
                       }else{
                           if(typeof response.data.message != 'object'){
                               this.alertMessage = response.data.message;
                           }else{
                               var array = new Array();
                               for (let key of Object.keys(response.data.message)) {
                                   let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                   array.push(obj)
                               }this.alertMessage = array.join(', ');
                           }
                                this.type = "danger";
                                this.loading = false;
                      }
                    })
                    .catch(error => {
                        this.loading = false;
                    })


      // this.$router.push({ path: "list" });
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
.modal-header {
  padding-bottom: 0;
}
</style>
